export var StatusEnum = ["available", "unavailable", "away", "dnd", "invisible", "eager"];
export var SizeEnum = ["xs", "sm", "md", "lg", "fluid"];
export var MessageTypeEnum = ["html", "text", "image", "custom"];
export default {
  SizeEnum: SizeEnum,
  StatusEnum: StatusEnum,
  MessageTypeEnum: MessageTypeEnum
};